export default class ThankYouHandler {
    constructor({ store }) {
        this._store = store;
    }

    async post({ orderId, assignmentId, message }) {
        try {
            const response = await this._store.$studentRepository.postThankYou(orderId, assignmentId, message);

            this._store.$bus.$emit('post_thank_you_success', {
                message: response.attributes.thankYou,
                publicReview: response.attributes.publicReviewUrl,
            });
        } catch (error) {
            this._store.$bus.$emit('post_thank_you_error');
        }
    }
}
